// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__209cb","selected":"Chip_selected__3eFal"};